import React, { useState, useEffect, useContext, useMemo } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import DatePicker from "react-datepicker";
import { initializeApp } from "firebase/app";
import { getMessaging, getToken } from "firebase/messaging";
import "react-datepicker/dist/react-datepicker.css";
import InputMask from "react-input-mask";
import Functions from '../../components/Functions'
//import moment from 'moment';
import logo from '../../assets/logo-home.png';
import './styles.css';
import '../../App.css';
import Loading from '../../components/Loading';
import camera from '../../assets/icons/camera.svg';
import Api from '../../services/Api'
import { useTranslation } from 'react-i18next';
import { useCountry } from '../../contexts/CountryContext';
import i18n from '../../i18n';

function Booking(props) {
  const { t } = useTranslation();
  const { countryConfig, changeCountry } = useCountry();
  const [loading, setLoading] = useState(true);
  const [business, setBusiness] = useState({});
  const [booking, setBooking] = useState({}); //{"modality":"Presencial","active":true,"_id":"628919c1063d630010c38db1","user":{"adminBusiness":true,"active":true,"_id":"621a6025a8b8af20772d8142","name":"Tweezer","email":"contato@tweezer.com.br","cpf":"034.900.370-06","phone":"(55) 98461-9162","business":"621b8185e0b4ed2240ce0f4b","updatedAt":"2022-05-08T00:47:37.850Z"},"customer":"621c3e3030034b3ac0e9609d","business":{"scheduling":"*","schedulingTime":90,"openingHours":[{"id":0,"hour":"08:00","seg":true,"ter":true,"qua":true,"qui":true,"sex":true,"sab":true,"dom":false},{"id":1,"hour":"08:30","seg":true,"ter":true,"qua":true,"qui":true,"sex":true,"sab":true,"dom":false},{"id":2,"hour":"09:00","seg":true,"ter":true,"qua":true,"qui":true,"sex":true,"sab":true,"dom":false},{"id":3,"hour":"09:30","seg":true,"ter":true,"qua":true,"qui":true,"sex":true,"sab":true,"dom":false},{"id":4,"hour":"10:00","seg":true,"ter":true,"qua":true,"qui":true,"sex":true,"sab":true,"dom":false},{"id":5,"hour":"10:30","seg":true,"ter":true,"qua":true,"qui":true,"sex":true,"sab":true,"dom":false},{"id":6,"hour":"11:00","seg":true,"ter":true,"qua":true,"qui":true,"sex":true,"sab":true,"dom":false},{"id":7,"hour":"11:30","seg":true,"ter":true,"qua":true,"qui":true,"sex":true,"sab":true,"dom":false},{"id":8,"hour":"13:30","seg":true,"ter":true,"qua":true,"qui":true,"sex":true,"sab":false,"dom":false},{"id":9,"hour":"14:00","seg":true,"ter":true,"qua":true,"qui":true,"sex":true,"sab":false,"dom":false},{"id":10,"hour":"14:30","seg":true,"ter":true,"qua":true,"qui":true,"sex":true,"sab":false,"dom":false},{"id":11,"hour":"15:00","seg":true,"ter":true,"qua":true,"qui":true,"sex":true,"sab":false,"dom":false},{"id":12,"hour":"15:30","seg":true,"ter":true,"qua":true,"qui":true,"sex":true,"sab":false,"dom":false},{"id":13,"hour":"16:00","seg":true,"ter":true,"qua":true,"qui":true,"sex":true,"sab":false,"dom":false},{"id":14,"hour":"16:30","seg":true,"ter":true,"qua":true,"qui":true,"sex":true,"sab":false,"dom":false},{"id":15,"hour":"17:00","seg":true,"ter":true,"qua":true,"qui":true,"sex":true,"sab":false,"dom":false},{"id":16,"hour":"17:30","seg":true,"ter":true,"qua":true,"qui":true,"sex":true,"sab":false,"dom":false},{"id":17,"hour":"18:00","seg":true,"ter":true,"qua":true,"qui":true,"sex":true,"sab":false,"dom":false}],"active":true,"_id":"621b8185e0b4ed2240ce0f4b","createdAt":"2022-02-27T10:49:57.442Z","updatedAt":"2022-05-04T22:01:09.941Z","__v":0,"CNPJ":"98.488.865/4654-65","address":{"street":"Rua São João XXIII","number":"203","district":"Centro","complement":"","city":"São Paulo","state":"SP"},"city":null,"description":"Bem vindo à nossa clínica, efetue seu agendamento através do formulário abaixo!","name":"Saúde Natural","plan":"622915790589ba0564aedcc9","razaoSocial":null,"state":null,"email":"contato@tweezer.com.br","phone":"(11) 99999-9999","currentDate":"2022-05-21T16:55:26.193Z"},"dateStart":"2022-05-21T09:30:00.000Z","dateEnd":"2022-05-21T11:00:00.000Z","status":"Agendado","iris":{"type":"","irisLeft":{"observations":"","images":[]},"irisRight":{"observations":"","images":[]}},"createdAt":"2022-05-21T16:56:33.170Z","updatedAt":"2022-05-21T16:56:33.170Z","__v":0}
  const [users, setUsers] = useState([]);
  const [customer, setCustomer] = useState({});
  const [hoursAvailable, setHoursAvailable] = useState([]);
  const [menu, setMenu] = useState("booking"); // booking-success
  const [msgErro, setMsgErro] = useState(false);
  const [formState, setFormState] = useState({
    modality: 'Presencial',
    dateStart: '', //new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60000))
    hourStart: '',
    name: '',
    phone: '',
    cpf: '',
    email: '',
    tokenDevice: '',
    user: {},
    iris: {type: "", irisLeft: { observations: "", images:[] }, irisRight: { observations: "", images:[] }}
  });

  useEffect(() => {
    if(countryConfig?.language){
      i18n.changeLanguage(countryConfig.language);
    }
  }, [countryConfig])

  // Firebase
  const appFirebase =  initializeApp(Functions.firebaseConfig);
  //const messaging = getMessaging(appFirebase);

  useEffect(() => {
    var idBusiness = "";
    //Se for no formato: /booking?business=621b8185e0b4ed2240ce0f4b
    if(props.history.location.search.indexOf('business=') !== -1){
      idBusiness = new URLSearchParams(location.search).get("business");
      console.log(idBusiness);
      if(idBusiness && idBusiness !== ""){
        getBusiness(idBusiness);
      } else {
        props.history.push('/');
      }
    //Se for no formato: /booking/621b8185e0b4ed2240ce0f4b
    } else if(props.history.location.pathname.split("/").length === 3 && props.history.location.pathname.split("/")[1] === "booking"){
      idBusiness = props.history.location.pathname.split("/")[2];
      console.log(idBusiness);
      if(idBusiness && idBusiness !== ""){
        getBusiness(idBusiness);
      } else {
        props.history.push('/');
      }
    //Se for no formato: /booking/621b8185e0b4ed2240ce0f4b/628919c1063d630010c38db1 - Agendamento Realizado
    } else if(props.history.location.pathname.split("/").length === 4 && props.history.location.pathname.split("/")[1] === "booking"){
      var idBooking = props.history.location.pathname.split("/")[3];
      idBusiness = props.history.location.pathname.split("/")[2];
      console.log(idBooking);
      if(idBusiness && idBusiness !== "" && idBooking && idBooking !== ""){
        getBusiness(idBusiness);
        getBooking(idBooking);
      } else {
        props.history.push('/');
      }
    } else {
      props.history.push('/');
    }
  }, []);

  async function getBusiness(idBusiness) {
    const response = await Api.getPublicBusiness(idBusiness);
    console.log(response);
    if(response && response?._id){
      console.log("Business found!")
      setBusiness(response);
      if (response.address?.country) {
        changeCountry(response.address.country);
      }
      loadUsers(idBusiness);
    } else {
      props.history.push('/');
    }
  }

  async function getBooking(idBooking) {
    const response = await Api.get(`/get-call/${idBooking}`);
    console.log(response);
    if(response && response?._id){
      setBooking(response);
      setMenu("booking-success");
      setLoading(false);
    } else {
      props.history.push('/');
    }
  }

  async function loadUsers(idBusiness) {
    setLoading(true);
    const response = await Api.get(`/get-users-business/${idBusiness}`);
    console.log(response);
    if(response && response.length > 0){
      setUsers(response);
      setFormState({
        ...formState,
        user: response[0]
      });
    }
    setLoading(false);
  }

  function onChangeDate(date) {
    setFormState({...formState, dateStart: date});
    getAvailableTimes(date);
  }

  async function getAvailableTimes(date) {
    setLoading(true);
    const response = await Api.get(`/get-available-times/${business._id}/${formState.user._id}/${date.toISOString().substr(0,10)}`);
    console.log(response);
    if(response){
      if(response?.message){
        setHoursAvailable([]);
        toast.error(response.message, {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      } else if(response.length > 0){
        console.log(response);
        setHoursAvailable(response);
        setFormState({...formState, dateStart: date, hourStart: response[0].hour});
      } else {
        toast.error(t('booking.errors.noAvailableTimes'), {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
        setHoursAvailable([]);
      }
    } else {
      setHoursAvailable([]);
    }
    setLoading(false);
  }

  async function onBlurCPF() {
    if(formState.cpf !== "" && formState.cpf !== "___.___.___-__"){
      const response = await Api.get(`/get-customer-cpf/${business._id}/${formState.cpf}`);
      console.log(response);
      if(response && response?._id){
        setFormState({
          ...formState,
          cpf: response.cpf,
          name: response.name,
          phone: response?.phone ? response.phone : "",
          email: response?.phone ? response.email : "",
          tokenDevice: response?.tokenDevice ? response.tokenDevice: ""
        });
        setCustomer(response);
      } else {
        setCustomer({});
      }
    } else {
      setCustomer({});
    }
  }

  const previewImagesIrisRight = useMemo(() => {
    let arrImages = [];
    Array.from(formState.iris.irisRight.images).map(itemImg => {
      if(typeof itemImg === "object"){
        let obj = URL.createObjectURL(itemImg);
        arrImages.push(obj); 
      }
    });
    console.log(arrImages);
    return arrImages;
  }, [formState.iris.irisRight.images]);

  const previewImagesIrisLeft = useMemo(() => {
    let arrImages = [];
    Array.from(formState.iris.irisLeft.images).map(itemImg => {
      if(typeof itemImg === "object"){
        let obj = URL.createObjectURL(itemImg);
        arrImages.push(obj); 
      }
    });
    console.log(arrImages);
    return arrImages;
  }, [formState.iris.irisLeft.images]);

  async function onChangeImagesRight(e){
    let arrImages = Array.from(formState.iris.irisRight.images);
    if(e.target.files.length > 0){    
      for(let i = 0; i < e.target.files.length; i++){
        if(parseInt(e.target.files[i].size) >= 5240000) {
          toast.error(t('booking.irisImages.imageError', { name: e.target.files[i].name }), {
            position: toast.POSITION.BOTTOM_RIGHT,
          });
        } else { 
          arrImages.push(e.target.files[i]);
          console.log(arrImages);
        }
      }
      setFormState({...formState, iris: {...formState.iris, irisRight: {...formState.iris.irisRight, images: arrImages } } })
    }
  };

  function onChangeImagesLeft(e){
    let arrImages = Array.from(formState.iris.irisLeft.images);
    if(e.target.files.length > 0){    
      for(let i = 0; i < e.target.files.length; i++){
        if(parseInt(e.target.files[i].size) >= 5240000) {
          toast.error(t('booking.irisImages.imageError', { name: e.target.files[i].name }), {
            position: toast.POSITION.BOTTOM_RIGHT,
          });
        } else { 
          arrImages.push(e.target.files[i]);
          console.log(arrImages);
        }
      }
      setFormState({...formState, iris: {...formState.iris, irisLeft: {...formState.iris.irisLeft, images: arrImages } } })
    }
  };

  function deleteIrisRight(index){
    var arrImages = Array.from(formState.iris.irisRight.images);
    arrImages.splice(index, 1)
    console.log(arrImages);
    setFormState({...formState, iris: {...formState.iris, irisRight: {...formState.iris.irisRight, images: arrImages } } })
  }

  function deleteIrisLeft(index){
    var arrImages = Array.from(formState.iris.irisLeft.images);
    arrImages.splice(index, 1);
    console.log(arrImages);
    setFormState({...formState, iris: {...formState.iris, irisLeft: {...formState.iris.irisLeft, images: arrImages } } })
  }

  function sendWhatsapp(){
    var whatsapp = booking.user?.phone && booking.user.phone !== "" ? booking.user.phone : booking.business.phone;
    var text = `-----------------------------------------------------------
${t('booking.whatsapp.title')}
-----------------------------------------------------------\n
  ${t('booking.whatsapp.client')} ${booking.customer.name}\n
  ${t('booking.whatsapp.date')} ${booking.dateStart.substr(0,10).split("-").reverse().join("/")}\n
  ${t('booking.whatsapp.time')} ${booking.dateStart.substr(11,5)}h\n
  ${t('booking.whatsapp.modality')} ${booking.modality}\n
  ${t('booking.whatsapp.clinic')} ${booking.business.name}\n
  ${t('booking.whatsapp.therapist')} ${booking.user.name}\n
  ${t('booking.whatsapp.status')} ${booking.status}\n
-----------------------------------------------------------
${t('booking.whatsapp.moreDetails')} https://eiris.app/booking/${business._id}/${booking._id}
-----------------------------------------------------------
    `;
    console.log(booking);
    window.open(Functions.sendWhatsApp(whatsapp, text), "_Blank");
  }

  const askForPermissionToReceiveNotifications = async () => {
    try {
      const messaging = getMessaging();
      getToken(messaging, { vapidKey: Functions.vapidKey }).then((currentToken) => {
        if (currentToken) {
          console.log('Token device:', currentToken);
          setFormState({...formState, tokenDevice: currentToken});
          toast.success(t('booking.notifications.success'), {
            position: toast.POSITION.BOTTOM_RIGHT,
          });
          //Update Token Customer Device
          // ...
        } else {
          // Show permission request UI
          console.log('No registration token available. Request permission to generate one.');
          toast.error(t('booking.notifications.error'), {
            position: toast.POSITION.BOTTOM_RIGHT,
          });
        }
      }).catch((err) => {
        console.log('An error occurred while retrieving token. ', err);
        toast.error(t('booking.notifications.browserError'), {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      });
    } catch (error) {
      console.error(error);
    }
  }

  async function sendBooking(e){
    e.preventDefault();
    if(formState.dateStart === "" || formState.hourStart === "" || formState.name === "" || formState.cpf === "" || formState.phone === ""){
      toast.error(t('booking.submit.requiredFieldsError'), {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      return;
    } else {
      var iris = formState.iris, arrImagesIrisRight = Array.from(formState.iris.irisRight.images), arrImagesIrisLeft = Array.from(formState.iris.irisLeft.images);
      //Cria um estrutura Multiform Data;
      const data = new FormData();
      setLoading(true);
      if(formState.modality === "Online"){
        if(arrImagesIrisLeft.length <= 0){
          toast.error(t('booking.irisImages.requiredImagesError', { side: t('business.irisLeft') }), {
            position: toast.POSITION.BOTTOM_RIGHT,
          });
          setLoading(false);
          return;
        }
        if(arrImagesIrisRight.length <= 0){
          toast.error(t('booking.irisImages.requiredImagesError', { side: t('business.irisRight') }), {
            position: toast.POSITION.BOTTOM_RIGHT,
          });
          setLoading(false);
          return;
        }
        if(arrImagesIrisLeft.length > 3 || arrImagesIrisRight.length > 3) {
          toast.error(t('booking.irisImages.maxImagesError'), {
            position: toast.POSITION.BOTTOM_RIGHT,
          });
          setLoading(false);
          return;
        }
        //Add images IRIS RIGHT
        console.log(arrImagesIrisRight);
        arrImagesIrisRight.length > 0 && arrImagesIrisRight.map(function(image, index) {
          if(typeof image === "object"){
            if(index === 0) {
              iris.irisRight.images = [];
            }
            if(iris.irisRight.images.indexOf(image.name) === -1){
              //iris.irisRight.images = [...iris.irisRight.images, image.name];
              iris.irisRight.images[index] = image.name;
              data.append('files', image);
            }
          } else {
            iris.irisRight.images[index] = image;
          }
        });
        //Add images IRIS LEFT
        console.log(arrImagesIrisLeft);
        arrImagesIrisLeft.length > 0 && arrImagesIrisLeft.map(function(image, index) {
          if(typeof image === "object"){
            if(index === 0) {
              iris.irisLeft.images = [];
            }
            if(iris.irisLeft.images.indexOf(image.name) === -1){
              //iris.irisLeft.images = [...iris.irisLeft.images, image.name];
              iris.irisLeft.images[index] = image.name;
              data.append('files', image);
            }
          } else {
            iris.irisLeft.images[index] = image;
          }
        });
      }
      data.append('iris', JSON.stringify(iris));
      data.append('business', business._id);
      data.append('user', formState.user._id);
      data.append('customer', customer?._id ? customer._id : JSON.stringify({
        name: formState.name,
        cpf: formState.cpf,
        phone: formState.phone,
        email: formState.email,
        tokenDevice: formState.tokenDevice
      }));
      //data.append('dateStart', new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60000)).toISOString());
      data.append('dateStart', formState.dateStart.toISOString().substr(0,10) + "T" + formState.hourStart + ":00.000Z");
      data.append('schedulingTime', business?.schedulingTime ? business.schedulingTime : 60);
      data.append('status', "Agendado");
      data.append('modality', formState.modality);
      //data.append('observations', formState.observations);
      try {
        const response = await Api.post("/update-call", data);
        console.log(response);
        if(response.hasOwnProperty('_id')){
          toast.success(t('booking.submit.success'), {
            position: toast.POSITION.BOTTOM_RIGHT,
          });
          var responseBooking = response;
          responseBooking.user = formState.user;
          responseBooking.business = business;
          responseBooking.customer = customer?._id ? customer : {
            name: formState.name,
            cpf: formState.cpf,
            phone: formState.phone,
            email: formState.email,
            tokenDevice: formState.tokenDevice
          };
          console.log(responseBooking);
          setBooking(responseBooking);
          setMenu("booking-success");
          setFormState({
            modality: 'Presencial',
            dateStart: new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60000)),
            hourStart: '',
            name: '',
            phone: '',
            cpf: '',
            email: '',
            tokenDevice: '',
            user: users[0],
            iris: {type: "", irisLeft: { observations: "", images:[] }, irisRight: { observations: "", images:[] }}
          });
          setLoading(false);
          props.history.push(`/booking/${business._id}/${response._id}`);
          //window.location.reload();
        } else {
          toast.error(t('booking.submit.error'), {
            position: toast.POSITION.BOTTOM_RIGHT,
          });
          setLoading(false);
        }
      } catch (error) {
        console.log(error);
      }
    }
  }

  return (<>
    {loading ?
      <Loading visible={loading}/>
    :
      <div className="container">
        <div className="booking">
          {/*<img id="logo" src={logo}/>
          <h1 id="logo" >e-iris.</h1> */} 
          <div className="header text-center">
            <label id="imgBusiness" style={business?.thumbnail ? { backgroundImage: `url("${encodeURI(business.thumbnail)}")` } : { backgroundImage: `url("${logo}")`, border:"border: 3px solid #09c4a9"}}></label>
            <h3>{business.name}</h3>
            <p>{business.description}</p>
            {business?.address && business.address?.street ?
              <p style={{marginBottom: 5}}><i className="fa fa-map-marker-alt"></i> {business.address.street + ", " + business.address.number + ", " + business.address.district + ", " + business.address.city + " - " + business.address.state + ", " + business.address.country}</p>
            : <></>}
            <div className="row">
              <div className="col-12 text-center">
                {business?.phone ?
                  <a href={"tel:"+business.phone}> <i className="fa fa-phone"></i> {business.phone}</a>
                : <></>}
                {business?.email ?
                  <a href={"mailto:"+business.email} style={{marginLeft: 5}}> <i className="fa fa-envelope"></i> {business.email}</a>
                : <></>}
              </div>
            </div>
          </div>
          {menu === "booking" ? 
            <div className="row">
              <div className="col-12">
                <div className="content">
                  <div className="text-center">
                    <h3>{t('booking.title')}</h3>
                    <p style={{color: "#999"}}>{t('booking.subtitle')}</p>
                  </div> 
                  <br/>
                  <p>{t('booking.modality.title')}</p>
                  <form onSubmit={sendBooking}>
                    <div className="row">
                      <div className="col-md-12 col-12 text-center">
                        <div className="divButtonSelect">
                          <div className={formState.modality === "Presencial" ? "itemButtonSelect active text-center" : "itemButtonSelect text-center" } onClick={() => setFormState({...formState, modality: "Presencial"})} style={{borderRight: "1px solid #ced4da"}}> 
                            <span>{t('booking.modality.inPerson')}</span>
                          </div>
                          <div className={formState.modality === "Online" ? "itemButtonSelect active text-center" : "itemButtonSelect text-center" } onClick={() => setFormState({...formState, modality: "Online"})}> 
                            <span>{t('booking.modality.online')}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    {users.length > 1 ?
                    <>
                      <p>{t('booking.professional.title')}</p>
                      <div className="row">
                        <div className="col-md-12 col-12 form-group">
                          <label className="labelInput">{t('booking.professional.label')}</label>
                          <select className="form-control" onChange={event => setFormState({...formState, user: JSON.parse(event.target.value)})} >
                            {users.map((el) => (
                              <option key={el._id} value={JSON.stringify(el)}>{el.name}</option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </>
                    : <></>}
                    <p>{t('booking.schedule.title')}</p>
                    <div className="row">
                      <div className="col-md-6 col-12 form-group">
                        <label className="labelInput">{t('booking.schedule.date')}</label>
                        <DatePicker 
                          className="form-control"
                          selected={formState.dateStart} 
                          onChange={(date) => onChangeDate(date)} 
                          minDate={new Date()}
                          dateFormat={'dd/MM/yyyy'}
                          placeholderText={t('booking.schedule.datePlaceholder')}
                          locale={Functions.getLocaleDatePicker(t)}
                        />
                      </div>
                      <div className="col-md-6 col-12 form-group">
                        <label className="labelInput">{t('booking.schedule.time')}</label>
                        <select className="form-control" value={formState.hourStart} onChange={event => setFormState({...formState, hourStart: event.target.value})} placeholder={t('booking.schedule.timePlaceholder')}>
                          {hoursAvailable.map((el) => (
                            <option key={el.id} value={el.hour}>{el.hour}</option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <p>{t('booking.personalInfo.title')}</p>
                    <div className="row">
                      <div className="col-md-6 col-12 form-group">
                        <label className="labelInput">{t('booking.personalInfo.name')}</label>
                        <input 
                          disabled={customer?._id && customer._id !== "" ? "disabled" : ""}
                          type="text" 
                          className="form-control" 
                          placeholder={t('booking.personalInfo.namePlaceholder')}
                          value={formState.name}
                          onChange={event => setFormState({...formState, name: event.target.value})}
                        />
                      </div>    
                      <div className="col-md-6 col-12 form-group">
                        <label className="labelInput">{countryConfig.documents.individual.name}</label>
                        <InputMask
                          mask={countryConfig.documents.individual.mask}
                          type="text" 
                          className="form-control" 
                          placeholder={countryConfig.documents.individual.name}
                          value={formState.cpf}
                          onChange={event => setFormState({...formState, cpf: event.target.value})}
                          onBlur={onBlurCPF}
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="form-group col-md-6 col-12">
                        <label className="labelInput">{t('booking.personalInfo.phone')}</label>
                        <InputMask 
                          disabled={customer?._id && customer._id !== "" ? "disabled" : ""}
                          mask={countryConfig.phone.mask}
                          className="form-control" 
                          placeholder={t('booking.personalInfo.phonePlaceholder')}
                          value={formState.phone}
                          onChange={event => setFormState({...formState, phone: event.target.value}) }
                        />
                      </div>
                      <div className="col-md-6 col-12 form-group">
                        <label className="labelInput">{t('booking.personalInfo.email')}</label>
                        <input 
                          disabled={customer?._id && customer._id !== "" ? "disabled" : ""}
                          type="email" 
                          className="form-control" 
                          name="email" 
                          id="email" 
                          placeholder={t('booking.personalInfo.emailPlaceholder')}
                          value={formState.email}
                          onChange={event => setFormState({...formState, email: event.target.value})}
                        />
                      </div>
                    </div>
                    {formState.modality === "Online" ?
                    <>
                      <p>{t('booking.irisImages.title')}</p>
                      <span>{t('booking.irisImages.instructions')}</span>
                      <br />
                      <div className="row">
                        <div className="col-12 col-md-6 form-group">
                          <p style={{marginBottom: 5, marginLeft: 5, fontWeight: "initial"}}>{t('booking.irisImages.leftIris')}</p>
                          <div className="listViewIris">
                            {previewImagesIrisLeft.map((item, index) => {
                              return (
                                <div key={item.toString()} className="divImgListViewIris">
                                  <label style={{ backgroundImage: `url("${item}")` }} className={'imgListViewIris'}>
                                  </label>
                                  <span className="deleteViewIris" onClick={() => deleteIrisLeft(index)}> <i className="fas fa-trash"> </i></span>
                                </div>
                              )
                            })}
                            <label className={'imgListViewIris addImgViewIris'}>
                              <input type="file" multiple accept="image/*" onChange={onChangeImagesLeft} />
                              <span>
                                <img src={camera} alt="Select img" />
                                <p>{t('booking.irisImages.addImages')}</p>
                              </span>
                            </label>
                          </div>
                        </div>
                        <div className="col-12 col-md-6 form-group">
                          <p style={{marginBottom: 5, marginLeft: 5, fontWeight: "initial"}}>{t('booking.irisImages.rightIris')}</p>
                          <div className="listViewIris">
                            {previewImagesIrisRight.map((item, index) => {
                              return (
                                <div key={item.toString()} className="divImgListViewIris">
                                  <label style={{ backgroundImage: `url("${item}")` }} className={'imgListViewIris'}>
                                  </label>
                                  <span className="deleteViewIris" onClick={() => deleteIrisRight(index)}> <i className="fas fa-trash"> </i></span>
                                </div>
                              )
                            })}
                            <label className={'imgListViewIris addImgViewIris'}>
                              <input type="file" multiple accept="image/*" onChange={onChangeImagesRight} />
                              <span>
                                <img src={camera} alt="Select img" />
                                <p>{t('booking.irisImages.addImages')}</p>
                              </span>
                            </label>
                          </div>
                        </div>
                      </div>
                    </>
                    : <>
                      {/*<div className="row">
                        <div className="col-md-12 col-12 form-group">
                          <input
                            disabled={formState.tokenDevice !== "" ? "disabled" : ""}
                            type="checkbox"
                            checked={formState.tokenDevice !== "" ? true : false}
                            onChange={askForPermissionToReceiveNotifications} 
                            style={{cursor: "pointer", margin: "0px 5px 0px 5px"}}
                          />
                          {t('booking.notifications.title')}
                        </div>
                      </div>*/}
                    </> }
                    <hr />
                    <div className="text-center">
                      <button type="submit" className="btn btn-default col-md-6 col-10">{t('booking.submit.button')}</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          : <>
            {menu === "booking-success" ?
              <div className="row">
                <div className="col-12 text-center">
                  <br />
                </div>
                <div className="col-12 text-center bookingSuccess">
                  <br />
                  <div className="text-center">
                    <h5>{t('booking.success.title')}</h5>
                  </div>  
                  <br />
                  {booking?._id ? 
                  <>
                    <div className="row">
                      <div className="col-12 col-md-6">
                        <div>{t('booking.success.client')} <b>{booking.customer.name}</b></div>
                        <div>{t('booking.success.therapist')} <b>{booking.user.name}</b></div>
                        <div>{t('booking.success.modality')} <b>{booking.modality}</b></div>
                      </div>  
                      <div className="col-12 col-md-6">
                        <div>{t('booking.success.date')} <b>{booking.dateStart.substr(0,10).split("-").reverse().join("/")}</b></div>
                        <div>{t('booking.success.time')} <b>{booking.dateStart.substr(11,5)}h</b></div>
                        <div>{t('booking.success.status')} <b>{booking.status}</b></div>
                      </div>
                    </div>
                  </>
                  : <></> }
                  <br /><br />
                  {(booking.user?.phone && booking.user.phone != "") || (booking.business?.phone && booking.business.phone != "") ? 
                    <div className="text-center">
                      <button type="button" className="btn btn-default" onClick={() => sendWhatsapp()}><i className="fab fa-whatsapp fa-lg"> </i> {t('booking.success.shareWhatsapp')}</button>
                    </div>  
                  : <></> }
                  <br />
                </div>
                <div className="col-12 text-center">
                  <br />
                </div>
              </div>
            : <></> }
          </>}
          <div className="row">
            <div className="col-12 text-center">
                <p style={{fontSize: 14}}>{t('booking.footer')} <b style={{fontSize: 20}}><a href="https://eiris.app" target="_Blank">e-iris.</a></b></p>
            </div>
          </div>
        </div>
        {/*<div className="divBtnNotification" onClick={askForPermissionToReceiveNotifications}>
          <i className="fa fa-bell fa-lg"></i>
        </div>*/}
        <ToastContainer />
      </div>
    }
  </>);
}

export default Booking;
